// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-3,\n.section-4 {\n  align-items: flex-start;\n  display: flex;\n  padding: 0 55px;\n  position: relative;\n}\n\n.what-would-you-like-to-sing-to-today,\n.what-would-you-like-to-sing-to-today-1 {\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
